import { render } from "./IconTrekFrameset.vue?vue&type=template&id=a3ea10bc"
import script from "./IconTrekFrameset.vue?vue&type=script&lang=js"
export * from "./IconTrekFrameset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__